// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.payContainer {
  width: 100%;
  /* height: 65vh; */
  /* background-color: aqua; */
  margin-top: 130px;
  margin-bottom: 30px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
}

.success-container {
  background-color: #ebebeb;
  border-radius: 10px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  padding: 40px;
  max-width: 500px;
  width: 100%;
  text-align: center;
}

.success-icon {
  width: 80px;
  height: 80px;
  background-color: #4caf50;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 0 auto 20px;
}

.success-icon i {
  color: white;
  font-size: 40px;
}

.successTxt {
  color: #4caf50;
  margin-bottom: 15px;
  font-size: 28px;
}

.pay-failed-text {
  color: #555;
  margin-bottom: 25px;
  line-height: 1.6;
}

.order-details {
  background-color: #f9f9f9;
  border-radius: 8px;
  padding: 15px;
  margin: 20px 0;
  text-align: left;
}

.detail-row {
  display: flex;
  justify-content: space-between;
  margin-bottom: 10px;
}

.detail-row:last-child {
  margin-bottom: 0;
}

.detail-label {
  color: #777;
}

.detail-value {
  color: #333;
  font-weight: 500;
}

.btn {
  display: inline-block;
  background-color: #4caf50;
  color: white;
  text-decoration: none;
  padding: 12px 30px;
  border-radius: 5px;
  font-weight: bold;
  /* transition: background-color 0.3s; */
  border: none;
  cursor: pointer;
  font-size: 16px;
  margin-top: 10px;
}

.btn:hover {
  background-color: #45a049;
}

.secure-note {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 20px;
  color: #666;
  font-size: 14px;
}

.secure-note i {
  color: #4caf50;
  margin-right: 8px;
}
`, "",{"version":3,"sources":["webpack://./src/pages/general/paymentSuccess/PaymentSuccess.css"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,kBAAkB;EAClB,4BAA4B;EAC5B,iBAAiB;EACjB,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,yCAAyC;EACzC,aAAa;EACb,gBAAgB;EAChB,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;EACb,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;EACrB,yBAAyB;EACzB,YAAY;EACZ,qBAAqB;EACrB,kBAAkB;EAClB,kBAAkB;EAClB,iBAAiB;EACjB,uCAAuC;EACvC,YAAY;EACZ,eAAe;EACf,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;EAChB,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,iBAAiB;AACnB","sourcesContent":[".payContainer {\n  width: 100%;\n  /* height: 65vh; */\n  /* background-color: aqua; */\n  margin-top: 130px;\n  margin-bottom: 30px;\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  justify-content: center;\n}\n\n.success-container {\n  background-color: #ebebeb;\n  border-radius: 10px;\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);\n  padding: 40px;\n  max-width: 500px;\n  width: 100%;\n  text-align: center;\n}\n\n.success-icon {\n  width: 80px;\n  height: 80px;\n  background-color: #4caf50;\n  border-radius: 50%;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  margin: 0 auto 20px;\n}\n\n.success-icon i {\n  color: white;\n  font-size: 40px;\n}\n\n.successTxt {\n  color: #4caf50;\n  margin-bottom: 15px;\n  font-size: 28px;\n}\n\n.pay-failed-text {\n  color: #555;\n  margin-bottom: 25px;\n  line-height: 1.6;\n}\n\n.order-details {\n  background-color: #f9f9f9;\n  border-radius: 8px;\n  padding: 15px;\n  margin: 20px 0;\n  text-align: left;\n}\n\n.detail-row {\n  display: flex;\n  justify-content: space-between;\n  margin-bottom: 10px;\n}\n\n.detail-row:last-child {\n  margin-bottom: 0;\n}\n\n.detail-label {\n  color: #777;\n}\n\n.detail-value {\n  color: #333;\n  font-weight: 500;\n}\n\n.btn {\n  display: inline-block;\n  background-color: #4caf50;\n  color: white;\n  text-decoration: none;\n  padding: 12px 30px;\n  border-radius: 5px;\n  font-weight: bold;\n  /* transition: background-color 0.3s; */\n  border: none;\n  cursor: pointer;\n  font-size: 16px;\n  margin-top: 10px;\n}\n\n.btn:hover {\n  background-color: #45a049;\n}\n\n.secure-note {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  margin-top: 20px;\n  color: #666;\n  font-size: 14px;\n}\n\n.secure-note i {\n  color: #4caf50;\n  margin-right: 8px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
